import React, { FC } from 'react';

import styles from './AppIcon.module.scss';
import LogoUploader from '../LogoUploader/LogoUploader';
import { iconSize } from 'constants/others';
import { PreviewSizeSelector } from 'components/ImagePreview/ImagePreview';
import { IAppIcon } from './AppIcon';

const AppIconImage: FC<IAppIcon> = ({ disabled, iconBackgroundColor }) => {
  return (
    <div className={styles['ta-app-icon__image__form']}>
      <LogoUploader
        className={styles['ta-app-icon__image__form__upload']}
        disabled={disabled}
        isFormSubmitSuccess
        allowedWidth={iconSize.width}
        imageFieldName='iconImageUrl'
        allowedHeight={iconSize.height}
        label='app.icon.box.image.label'
        note='app.icon.box.image.hintText'
        acceptFileTypes='image/png, image/jpeg, image/jpg'
        previewSize={PreviewSizeSelector.small}
        placeholder='app.icon.box.image.placeholder'
        notePlaceholders={[{ key: 'DIMENSIONS', value: '128x128px' }]}
        fileInputClassName={styles['ta-app-icon__image__form__upload__field']}
        // isFormSubmitSuccess={submitSucceeded && !modifiedSinceLastSubmit}
      />
    </div>
  );
};

export default AppIconImage;
